import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import * as CryptoJS from 'crypto-js';
import * as localforage from 'localforage';
import * as AES from 'crypto-js/aes';
import * as SHA256 from 'crypto-js/sha256';
import {BehaviorSubject, Observable} from 'rxjs/index';

@Injectable()
export class AuthenticationService {

  public isAuthenticated$: BehaviorSubject<boolean>;
  public isAuthenticated: Observable<boolean>;
  public token$: BehaviorSubject<string>;
  public token: Observable<string>;
  private access_token: string;
  public userApps: Observable<string[]>;

  constructor( private storageService: StorageService ) {
    const authStatus = this.getAuthenticated;
    this.isAuthenticated$ = new BehaviorSubject(authStatus);
    this.isAuthenticated = this.isAuthenticated$.asObservable();
    this.isAuthenticated.subscribe();

    this.token$ = new BehaviorSubject('');
    this.token = this.token$.asObservable();
    this.token.subscribe();

    this.userApps = new Observable((observer) => {
      observer.next(['legiony', 'bilety']);
    });
    this.parseToken();
  }

  private get getAuthenticated(): boolean {
    return this.storageService.getItem('isLogged');
  }

  private parseToken(): void {
    localforage.getItem('user').then((data) => {
      if (data) {
        const decrypted = CryptoJS.AES.decrypt(data, 'secret');
        const userData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
        this.access_token = userData.token;
        this.token$.next(userData.token);
      } else {
        this.access_token = '';
        this.token$.next('');
      }
    }).catch(function(err) {
      console.log(err);
      this.access_token = '';
      this.token$.next('');
    });
  }

  public getToken(): string {
    return this.access_token;
  }

  public getRefreshToken(): Promise<string> {
    return new Promise((resolve) => {
      resolve(this.storageService.getItem('refreshToken'));
    });
  }

  public clearSignin() {
    this.storageService.clear();
    this.isAuthenticated$.next(false);
  }

  public parseRefreshToken(body: any): Promise<boolean> {
    return new Promise((resolve) => {
      this.storageService.setItem('token', body.token);
      this.storageService.setItem('refreshToken', body.refresh_token);
      resolve(true);
    });
  }


}
